export default {
    deviceName: 'Device Name',
    deviceNumber: 'Device Number',
    recordTime: 'Record Time',
    mapViewAll: 'Map View All',
    distance: 'Distance',
    flightAltitude: 'Flight altitude (altitude)',
    positionCoordinates: 'Position Coordinates',
    copyLocationData: 'Copy Location Data',
    detectionRecord: 'Detection Record',
}